export default __webpack_public_path__ + "static/media/screenshot2.f62a0160.jpg";